import React, { useEffect, useRef, useState } from 'react'
import {
    BooleanCheckBoxes,
    ImageGallery,
    MonthYearDatePicker,
    StickyContainer,
    ValidatedNameSignature,
    WarehouseDropDownList,
} from '../../../../GlobalComponents/awc-reactjs-components'
import AssemblyIDSelection from './AssemblyIDSelection'
import QRScan from './QRScan'
import { Typeahead } from 'react-bootstrap-typeahead'
import { modifyMissingRequiredLockLevelFields } from './Helpers/FormContainerHelperFunctions'
import {
    RadioGroup2,
    QuestionSection,
    WrappedTextArea,
    WrappedInput,
    WrappedNumericInput,
} from './Helpers/GetRenderDataHelpers'
import { getBaseURL } from '../../../../GlobalComponents/URLs'
import { FormHeader } from './FormHeader'
import { getSerialNumber } from './Helpers/DataHelpers'
import style from './GetRenderData.module.scss'

export default function GetRenderData(
    data,
    numLevels,
    missingRequiredLockLevelFields,
    handleFieldChange,
    handleSign,
    recordLockLevel,
    props,
    writer,
    handleFieldInvalid,
    setIsFirstError,
    fieldIsVisibleInCurrentFormView,
    canShowSection,
    renderTable,
    renderSectionTitleContainer,
    renderSectionTitle,
    stageChange,
    browserSupportsDateInputs,
    handleDateChange,
    handleKeyPress,
    setCurrentModal,
    disableFilter,
    signPreCheck,
    handleUIDSearchClick,
    handleGalleryAddPicture,
    handleGalleryAttachmentUpdateFields,
    handleGalleryImageSort,
    handleGalleryOnClickRemoveSelectedPictures,
    disableSubmits,
    formOrError,
    signatureFields,
    setSignatureFields,
    setMissingRequiredLockLevelFields,
    setNumLevels,
    requiredLockLevelFields,
    lockedLevels,
    appLock,
    handleAssemblyIDSelection,
    aWCAssemblyUIDList,
    newAssemblyIDClick,
    handleAssemblyIdChange,
    handleQrScan,
    formId,
    setFormViewId,
    fieldChanged,
    recordId,
    setIsMenuOpen,
    isMenuOpen,
    lockState,
    lockedLevelsArray,
    refRecordId,
    isQRModalVisible,
    handleQRCloseModal,
    handleScanComplete,
    setAssemblyError,
    isAssemblySearchModalVisible,
    handleAssemblyResultsCloseModal,
    apiData,
    handleAssemblySearchConfirm,
    isAssemblyModalVisible,
    handleAssemblyCloseModal,
    showAssemblyAlert,
    assemblyError,
    saveButtonRendered,
    showVersionOutOfDateAlert,
    showAssemblyInfo,
    assemblyInfo,
    saving,
    savedTime,
    setSaveButtonRendered,
    onSubmit,
    currentUser,
    versionNumber,
    setAssemblyInfo,
    handleReadOnly,
    isPOModalVisible,
    handlePOCloseModal,
    handlePOComplete,
    showAssemblyListModal,
    setShowAssemblyListModal,
    canUnlock,
    setShowConfirmModal
) {
    return () => {
        const toggleMenu = () => setIsMenuOpen(!isMenuOpen)
        const closeMenu = () => setIsMenuOpen(false)
        const FREEZE_UOM_START = {
            SetPressureUOM: true,
        }
        const FREEZE_UOM_END = {
            FinalPopTestUOM: true,
        }
        const AVERAGE_FIELDS = {
            PopAverage: true,
            TestAverage: true,
        }

        let startTime = new Date()
        let renderCount = 0
        // main array of page elements
        let elements = []
        let section_children = []
        let sections_children = []
        let table_children = []
        const form = data?.FormSectionFieldValueView?.[0]?.Form
        if (!form) {
            return null // Prevent rendering the component if 'form' is not available
        }
        const version = data.FormSectionFieldValueView[0].VersionNumber

        renderCount += 1
        elements.push(
            FormHeader(
                form,
                version,
                data,
                setFormViewId,
                //handlePrint,
                recordId,
                formId,
                toggleMenu,
                closeMenu,
                lockState,
                numLevels,
                setCurrentModal,
                lockedLevelsArray,
                recordLockLevel,
                refRecordId,
                isMenuOpen,
                isQRModalVisible,
                handleQRCloseModal,
                handleScanComplete,
                setAssemblyError,
                isAssemblySearchModalVisible,
                handleAssemblyResultsCloseModal,
                apiData,
                handleAssemblySearchConfirm,
                isAssemblyModalVisible,
                handleAssemblyCloseModal,
                assemblyError,
                saveButtonRendered,
                fieldChanged,
                showVersionOutOfDateAlert,
                assemblyInfo,
                saving,
                savedTime,
                setSaveButtonRendered,
                disableSubmits,
                formOrError,
                onSubmit,
                currentUser,
                versionNumber,
                handleSign,
                lockedLevels,
                setAssemblyInfo,
                handleReadOnly,
                isPOModalVisible,
                handlePOCloseModal,
                handlePOComplete,
                canUnlock,
                setShowConfirmModal
        
            )
        )

        let lastSectionId = ''
        let lastTableId = null
        let inTable = false
        let maxLevel = numLevels

        let newMissingRequiredLockLevelFields = missingRequiredLockLevelFields
        let bMissingRequiredLockLevelFieldsChanged = false
        let newSignatureFields = []

        data.FormSectionFieldValueView.forEach((fdata, i) => {
            if (fdata.IsHidden) return
            let form_group_children = []
            const inputId = `${fdata.RecordId}|${
                fdata.FormSectionFieldId
            }|${fdata.DataType.toUpperCase()}`
            const fieldChangeFunc = handleFieldChange(
                fdata.RecordId,
                fdata.FormSectionFieldId,
                fdata.DataType,
                fdata.IsRequired,
                fdata.RequiredLockLevel,
                fdata.ValidationType,
                fdata.ChangeStageTo,
                fdata.FieldNameQuery
            )
            const handleSignFunc = handleSign(
                fdata.IncreaseLockLevel,
                recordLockLevel,
                fdata.FormSectionFieldId,
                true
            )

            let levelsArray = lockedLevels ? lockedLevels.split('|').map(Number) : []

            //let levelsArray = props.lockedLevels.split('|').map(Number)
            let isInArray = levelsArray.includes(fdata.LockLevel)
            if (recordLockLevel === 0) {
                isInArray = false
            }

            maxLevel = maxLevel < fdata.LockLevel ? fdata.LockLevel : maxLevel
            maxLevel = maxLevel < fdata.IncreaseLockLevel ? fdata.IncreaseLockLevel : maxLevel
            let isDisabled =
                lockState.locked ||
                props.locked ||
                (fdata.LockLevel !== 0 && isInArray) ||
                recordLockLevel < 0
            if (fdata.FormId === 130) isDisabled = isDisabled || !writer

            let isRequired = fdata.IsRequired && fdata.RequiredLockLevel <= recordLockLevel

            const fieldInvalidFunc = (e) => {
                handleFieldInvalid(e)
                setIsFirstError(true)
            }
            if (
                !fieldIsVisibleInCurrentFormView(fdata.FormSectionFieldId) ||
                !canShowSection(fdata.FormSectionId)
            )
                return
            if (lastTableId && fdata.FormFieldGroupId !== lastTableId) {
                let tableInfo = data.FormFieldGroup.find((x) => x.FormFieldGroupId === lastTableId)
                section_children.push(renderTable(table_children, tableInfo))
                table_children = []
            }
            inTable = !!fdata.FormFieldGroupId
            lastTableId = fdata.FormFieldGroupId
            if (fdata.FormSectionId !== lastSectionId) {
                if (lastSectionId !== '') {
                    sections_children.push(
                        renderSectionTitleContainer(`${lastSectionId}`, section_children)
                    )
                    section_children = []
                }
                section_children.push(
                    renderSectionTitle(`${i}SectionTitle`, fdata.Section.replace(/[|]/g, ' > '))
                )
                lastSectionId = fdata.FormSectionId
            }
            if (fdata.ValidationType.toUpperCase().startsWith('RADIOBUTTONGROUP')) {
                let options = {}
                data.FormSectionFieldOption.filter(
                    (o) => o.FormSectionFieldId === fdata.FormSectionFieldId
                ).forEach((option) => {
                    options[option.OptionValue.trim()] = option.OptionText
                })
                form_group_children.push(
                    <QuestionSection
                        formSectionFieldId={fdata.FormSectionFieldId}
                        onChange={fieldChangeFunc}
                        question={fdata.FieldName}
                        leftText={options['LEFT']}
                        rightText={options['RIGHT']}
                        range={options['RANGE']}
                        disabled={isDisabled}
                        defaultValue={fdata.StringFieldValue}
                    />
                )
            } else if (fdata.ValidationType.toUpperCase().startsWith('RADIOBUTTONS')) {
                let options = data.FormSectionFieldOption.filter(
                    (o) => o.FormSectionFieldId === fdata.FormSectionFieldId
                )
                form_group_children.push(
                    <RadioGroup2
                        formSectionFieldId={fdata.FormSectionFieldId}
                        onChange={fieldChangeFunc}
                        options={options}
                        disabled={isDisabled}
                        defaultValue={fdata.StringFieldValue}
                    />
                )
            } else if (fdata.DataType.toUpperCase() === 'IMAGE') {
                form_group_children.push(
                    React.createElement('img', {
                        name: inputId,
                        className: 'img-fluid',
                        src: `data:image;base64,${fdata.Diagram}`,
                        key: `${i}v`,
                    })
                )
            } else if (fdata.FieldNameQuery === 'OrderNumber') {
                form_group_children.push(
                    React.createElement(
                        'label',
                        {
                            key: `${i}order`,
                        },
                        <>
                            <div>{fdata.FieldName}</div>
                        </>
                    )
                )
                form_group_children.push(
                    React.createElement(WrappedInput, {
                        name: inputId,
                        type: 'text',
                        className: 'form-control form-control-sm',
                        value: data.OrderInfo[0].OrderNumber,
                        key: `${i}v`,
                        disabled: true, 
                    })
                )
            
            } else {
                form_group_children.push(
                    React.createElement(
                        'label',
                        {
                            key: `${i}l1`,
                        },
                        <div>
                            {fdata.FieldName}
                            {isRequired && (
                                <div style={{ color: 'red', display: 'inline' }}> *</div>
                            )}
                        </div>
                    )
                )
                if (fdata.ValidationType === '') {
                    if (fdata.DataType.toUpperCase() === 'BOOLEAN') {
                        form_group_children.push(
                            React.createElement(BooleanCheckBoxes, {
                                'data-changed': fdata.isChangedRow,
                                defaultChecked: fdata.BooleanFieldValue,
                                key: `${i}c`,
                                name: inputId,
                                id: inputId,
                                required: isRequired ? 'required' : '',
                                onChange: (e) => {
                                    fieldChangeFunc(e)
                                    stageChange(fdata, e.target.checkedValue)
                                },
                                // onBlur: ()=>stageChange(fdata, fdata.BooleanFieldValue),
                                disabled: isDisabled,
                            })
                        )
                        if (fdata.BooleanFieldValue !== undefined)
                            bMissingRequiredLockLevelFieldsChanged =
                                modifyMissingRequiredLockLevelFields(
                                    newMissingRequiredLockLevelFields,
                                    fdata.FormSectionFieldId,
                                    fdata.RequiredLockLevel,
                                    'remove'
                                ) || bMissingRequiredLockLevelFieldsChanged
                        //     modifyRequiredAtLockLevels(fdata.FormSectionFieldId, fdata.RequiredLockLevel, "remove");
                    } else if (fdata.DataType.toUpperCase() === 'DATE') {
                        let sd = null
                        if (fdata.DateFieldValue) {
                            bMissingRequiredLockLevelFieldsChanged =
                                modifyMissingRequiredLockLevelFields(
                                    newMissingRequiredLockLevelFields,
                                    fdata.FormSectionFieldId,
                                    fdata.RequiredLockLevel,
                                    'remove'
                                ) || bMissingRequiredLockLevelFieldsChanged
                            // modifyRequiredAtLockLevels(fdata.FormSectionFieldId, fdata.RequiredLockLevel, "remove");
                            const d = new Date(fdata.DateFieldValue)
                            let chromeFromInputRegex = /^\d{4}-\d{2}-\d{2}$/
                            if (chromeFromInputRegex.exec(fdata.DateFieldValue))
                                sd = fdata.DateFieldValue
                            else if (browserSupportsDateInputs())
                                sd = `${d.getFullYear().toString().padStart(4, '0')}-${(
                                    d.getMonth() + 1
                                )
                                    .toString()
                                    .padStart(2, '0')}-${d.getDate().toString().padStart(2, '0')}`
                            else
                                sd = `${(d.getMonth() + 1).toString().padStart(2, '0')}/${d
                                    .getDate()
                                    .toString()
                                    .padStart(2, '0')}/${d.getFullYear().toString()}`
                        }
                        form_group_children.push(
                            React.createElement('input', {
                                className: 'form-control form-control-sm',
                                value: sd ?? '',
                                'data-defaultvalue': sd ?? '',
                                'date-format': 'mm/dd/yyyy',
                                'data-changed': fdata.isChangedRow,
                                min: '1950-01-02',
                                max: '2200-01-02',
                                key: `${i}v`,
                                name: inputId,
                                onChange: (e) => {
                                    handleDateChange(e)
                                    fieldChangeFunc(e)
                                },
                                onKeyPress: handleKeyPress,
                                onInvalid: fieldInvalidFunc,
                                onBlur: () =>
                                    stageChange(
                                        fdata,
                                        fdata.DateFieldValue instanceof Date
                                            ? fdata.DateFieldValue.toISOString()
                                            : fdata.DateFieldValue
                                    ),
                                type: 'date',
                                required: isRequired ? 'required' : '',
                                disabled: isDisabled,
                            })
                        )
                    } else if (fdata.DataType.toUpperCase() === 'NUMERIC') {
                        if (fdata.NumericFieldValue !== null)
                            bMissingRequiredLockLevelFieldsChanged =
                                modifyMissingRequiredLockLevelFields(
                                    newMissingRequiredLockLevelFields,
                                    fdata.FormSectionFieldId,
                                    fdata.RequiredLockLevel,
                                    'remove'
                                ) || bMissingRequiredLockLevelFieldsChanged
                        // modifyRequiredAtLockLevels(fdata.FormSectionFieldId, fdata.RequiredLockLevel, "remove");
                        form_group_children.push(
                            React.createElement(WrappedNumericInput, {
                                name: inputId,
                                type: 'number',
                                step: fdata.NumericStep,
                                className: 'form-control form-control-sm',
                                value:
                                    fdata.NumericFieldValue !== null &&
                                    fdata.NumericFieldValue !== undefined
                                        ? fdata.NumericFieldValue.toString()
                                        : '',
                                onChange: (e) => {
                                    fieldChangeFunc(e)
                                    stageChange(fdata, e.target.value)
                                },
                                alertModal: ({ oldValue, newValue, step }) =>
                                    setAssemblyError(
                                        `Precision not supported for value ${newValue} (decimals beyond ${step} are not allowed).Value has been set back to the last value (${
                                            oldValue || 'No Value'
                                        })`
                                    ),
                                numericStep: fdata.NumericStep,
                                onKeyPress: handleKeyPress,
                                onInvalid: fieldInvalidFunc,
                                'data-changed': true,
                                key: `${i}v`,
                                required: isRequired ? 'required' : '',
                                disabled: isDisabled || AVERAGE_FIELDS[fdata.FieldNameQuery],
                            })
                        )
                    } else if (fdata.DataType.toUpperCase() === 'MEMO') {
                        if (fdata.MemoFieldValue === null) fdata.MemoFieldValue = ''
                        else if (fdata.MemoFieldValue !== '')
                            bMissingRequiredLockLevelFieldsChanged =
                                modifyMissingRequiredLockLevelFields(
                                    newMissingRequiredLockLevelFields,
                                    fdata.FormSectionFieldId,
                                    fdata.RequiredLockLevel,
                                    'remove'
                                ) || bMissingRequiredLockLevelFieldsChanged
                        // modifyRequiredAtLockLevels(fdata.FormSectionFieldId, fdata.RequiredLockLevel, "remove");
                        form_group_children.push(
                            React.createElement(WrappedTextArea, {
                                name: inputId,
                                rows: 5,
                                cols: 80,
                                className: 'form-control form-control-sm',
                                value: fdata.MemoFieldValue,
                                onChange: fieldChangeFunc,
                                onInvalid: fieldInvalidFunc,
                                onBlur: () => stageChange(fdata, fdata.MemoFieldValue),
                                'data-changed': fdata.isChangedRow,
                                maxLength: fdata.StringMaxLength > 0 ? fdata.StringMaxLength : null,
                                key: `${i}v`,
                                id: `${i}v`,
                                required: isRequired ? 'required' : '',
                                disabled: isDisabled,
                            })
                        )
                    } else {
                        if (fdata.StringFieldValue === null) fdata.StringFieldValue = ''
                        else if (fdata.StringFieldValue !== '')
                            bMissingRequiredLockLevelFieldsChanged =
                                modifyMissingRequiredLockLevelFields(
                                    newMissingRequiredLockLevelFields,
                                    fdata.FormSectionFieldId,
                                    fdata.RequiredLockLevel,
                                    'remove'
                                ) || bMissingRequiredLockLevelFieldsChanged
                        // modifyRequiredAtLockLevels(fdata.FormSectionFieldId, fdata.RequiredLockLevel, "remove");
                        form_group_children.push(
                            React.createElement(WrappedInput, {
                                name: inputId,
                                type: 'text',
                                className: 'form-control form-control-sm',
                                value: fdata.StringFieldValue,
                                onChange: fieldChangeFunc,
                                onKeyPress: handleKeyPress,
                                onInvalid: fieldInvalidFunc,
                                onBlur: () => stageChange(fdata, fdata.StringFieldValue),
                                'data-changed': fdata.isChangedRow,
                                maxLength:
                                    fdata.StringMaxLength > 0
                                        ? Math.min(50, fdata.StringMaxLength)
                                        : 50,
                                key: `${i}v`,
                                required: isRequired ? 'required' : '',
                                disabled: isDisabled || fdata.FieldNameQuery === 'CSAEtchDate', // current place
                            })
                        )
                    }
                } else if (fdata.ValidationType.toUpperCase() === 'DATE (MMYYYY)') {
                    let d = null
                    let sd = null
                    if (fdata.DateFieldValue) {
                        d = new Date(fdata.DateFieldValue)
                        bMissingRequiredLockLevelFieldsChanged =
                            modifyMissingRequiredLockLevelFields(
                                newMissingRequiredLockLevelFields,
                                fdata.FormSectionFieldId,
                                fdata.RequiredLockLevel,
                                'remove'
                            ) || bMissingRequiredLockLevelFieldsChanged
                        let chromeFromInputRegex = /^\d{4}-\d{2}-\d{2}$/
                        if (chromeFromInputRegex.exec(fdata.DateFieldValue))
                            sd = fdata.DateFieldValue
                        else if (browserSupportsDateInputs())
                            sd = `${d.getFullYear().toString().padStart(4, '0')}-${(
                                d.getMonth() + 1
                            )
                                .toString()
                                .padStart(2, '0')}-${d.getDate().toString().padStart(2, '0')}`
                        else
                            sd = `${(d.getMonth() + 1).toString().padStart(2, '0')}/${d
                                .getDate()
                                .toString()
                                .padStart(2, '0')}/${d.getFullYear().toString()}`
                    }
                    form_group_children.push(
                        React.createElement(MonthYearDatePicker, {
                            className: 'form-control form-control-sm',
                            selected: d,
                            'data-defaultvalue': sd,
                            'data-changed': fdata.isChangedRow,
                            minDate: new Date(1950, 1, 1),
                            maxDate: new Date(2200, 1, 1),
                            key: `${i}v`,
                            name: inputId,
                            onChange: (e) => {
                                let event = { target: { value: e || '' } }
                                handleDateChange(event)
                                fieldChangeFunc(
                                    e
                                        ? `${(e.getMonth() + 1).toString().padStart(2, '0')}/${e
                                              .getDate()
                                              .toString()
                                              .padStart(2, '0')}/${e.getFullYear().toString()}`
                                        : ''
                                )
                            },
                            onKeyPress: handleKeyPress,
                            onInvalid: fieldInvalidFunc,
                            onBlur: () =>
                                stageChange(
                                    fdata,
                                    fdata.DateFieldValue instanceof Date
                                        ? fdata.DateFieldValue.toISOString()
                                        : fdata.DateFieldValue
                                ),
                            required: isRequired ? 'required' : '',
                            disabled: isDisabled,
                        })
                    )
                } else if (fdata.ValidationType.toUpperCase() === 'EMAIL') {
                    if (fdata.StringFieldValue === null) fdata.StringFieldValue = ''
                    else if (fdata.StringFieldValue !== '')
                        bMissingRequiredLockLevelFieldsChanged =
                            modifyMissingRequiredLockLevelFields(
                                newMissingRequiredLockLevelFields,
                                fdata.FormSectionFieldId,
                                fdata.RequiredLockLevel,
                                'remove'
                            ) || bMissingRequiredLockLevelFieldsChanged
                    // modifyRequiredAtLockLevels(fdata.FormSectionFieldId, fdata.RequiredLockLevel, "remove");
                    form_group_children.push(
                        React.createElement('input', {
                            name: inputId,
                            type: 'email',
                            className: 'form-control form-control-sm',
                            value: fdata.StringFieldValue,
                            onChange: fieldChangeFunc,
                            onKeyPress: handleKeyPress,
                            onInvalid: fieldInvalidFunc,
                            onBlur: () => stageChange(fdata, fdata.StringFieldValue),
                            'data-changed': fdata.isChangedRow,
                            maxLength: 50,
                            key: `${i}v`,
                            required: isRequired ? 'required' : '',
                            disabled: isDisabled,
                        })
                    )
                } else if (fdata.ValidationType.toUpperCase() === 'DROP-DOWN LIST') {
                    // current place
                    if (fdata.StringFieldValue === null) fdata.StringFieldValue = ''
                    else if (fdata.StringFieldValue !== '')
                        bMissingRequiredLockLevelFieldsChanged =
                            modifyMissingRequiredLockLevelFields(
                                newMissingRequiredLockLevelFields,
                                fdata.FormSectionFieldId,
                                fdata.RequiredLockLevel,
                                'remove'
                            ) || bMissingRequiredLockLevelFieldsChanged
                    // modifyRequiredAtLockLevels(fdata.FormSectionFieldId, fdata.RequiredLockLevel, "remove");
                    let drop_down_options = []
                    drop_down_options.push(
                        React.createElement(
                            'option',
                            {
                                key: `${i}op`,
                                value: '',
                            },
                            fdata.IsRequired ? '-- Select One --' : ''
                        )
                    )
                    data.FormSectionFieldOption.filter(
                        (o) => o.FormSectionFieldId === fdata.FormSectionFieldId
                    ).forEach((option, index) => {
                        drop_down_options.push(
                            React.createElement(
                                'option',
                                {
                                    key: `${i}op${option.OptionValue.trim()}${index}`,
                                    value: option.OptionValue.trim(),
                                },
                                option.OptionText.trim()
                            )
                        )
                    })
                    form_group_children.push(
                        React.createElement(
                            'select',
                            {
                                name: inputId,
                                className: 'form-control form-control-sm',
                                defaultValue: fdata.StringFieldValue,
                                onChange: (e) => {
                                    fieldChangeFunc(e)
                                    stageChange(fdata, e.target.value)
                                },
                                onBlur: (e) => {
                                    fieldChangeFunc(e)
                                    stageChange(fdata, e.target.value)
                                },
                                onKeyPress: handleKeyPress,
                                onInvalid: fieldInvalidFunc,
                                'data-changed': fdata.isChangedRow,
                                key: `${i}v`,
                                required: isRequired ? 'required' : '',
                                disabled: isDisabled || FREEZE_UOM_END[fdata.FieldNameQuery],
                            },
                            drop_down_options
                        )
                    )
                } else if (fdata.ValidationType.toUpperCase() === 'COMBOBOX') {
                    if (fdata.StringFieldValue === null) fdata.StringFieldValue = ''
                    else if (fdata.StringFieldValue !== '')
                        bMissingRequiredLockLevelFieldsChanged =
                            modifyMissingRequiredLockLevelFields(
                                newMissingRequiredLockLevelFields,
                                fdata.FormSectionFieldId,
                                fdata.RequiredLockLevel,
                                'remove'
                            ) || bMissingRequiredLockLevelFieldsChanged
                    // modifyRequiredAtLockLevels(fdata.FormSectionFieldId, fdata.RequiredLockLevel, "remove");
                    let combobox_options = []
                    data.FormSectionFieldOption.filter(
                        (o) => o.FormSectionFieldId === fdata.FormSectionFieldId
                    ).forEach((option) => {
                        combobox_options.push({
                            text: option.OptionText.trim(),
                            value: option.OptionValue.trim(),
                        })
                    })
                    form_group_children.push(
                        <div className={fdata.invalid ? 'field-invalid' : ''}>
                            {React.createElement(Typeahead, {
                                align: 'left',
                                bsSize: 'small',
                                'data-changed': fdata.isChangedRow,
                                value: fdata.StringFieldValue,
                                selected: [fdata.StringFieldValue],
                                filterBy: disableFilter,
                                labelKey: 'text',
                                key: `${i}v`,
                                id: inputId,
                                name: inputId,
                                // onFocus: fieldChangeFunc,
                                onBlur: (e) => {
                                    fieldChangeFunc(e)
                                    stageChange(fdata, fdata.StringFieldValue)
                                },
                                onChange: (e) => {
                                    if (e.length === 0 || !e[0].value) {
                                        return
                                    }
                                    let e2 = {}
                                    // format event object to match for fieldChange
                                    e2.target = {
                                        value: e[0].value,
                                        setCustomValidity: () => null,
                                    }
                                    fieldChangeFunc(e2)
                                },
                                onKeyPress: handleKeyPress,
                                onInvalid: fieldInvalidFunc,
                                options: combobox_options,
                                valueKey: 'value',
                                // isInvalid: true,
                                inputProps: {
                                    //required: isRequired ? 'required' : '',
                                    maxLength: 50,
                                },
                                disabled: isDisabled,
                            })}
                        </div>
                    )
                } else if (fdata.ValidationType.toUpperCase() === 'MULTI-SELECT') {
                    if (fdata.StringFieldValue === null) fdata.StringFieldValue = ''

                    let selectedValues = data.FormSectionFieldMultiValue.filter(
                        (x) =>
                            x.FormSectionFieldId === fdata.FormSectionFieldId &&
                            x.RecordId === fdata.RecordId
                    ).map((y) => {
                        let correspondingOption = data.FormSectionFieldOption.find(
                            (option) =>
                                option.FormSectionFieldId === fdata.FormSectionFieldId &&
                                option.OptionValue.trim().toUpperCase() ===
                                    y.StringFieldValue.trim().toUpperCase()
                        )

                        return {
                            text: correspondingOption.OptionText.trim(),
                            value: y.StringFieldValue.trim(),
                            valueId: y.ValueId,
                        }
                    })
                    if (fdata.RequiredLockLevel > 0 || fdata.IsRequired)
                        bMissingRequiredLockLevelFieldsChanged =
                            modifyMissingRequiredLockLevelFields(
                                newMissingRequiredLockLevelFields,
                                fdata.FormSectionFieldId,
                                fdata.RequiredLockLevel,
                                selectedValues.length > 0 ? 'remove' : 'add'
                            ) || bMissingRequiredLockLevelFieldsChanged
                    // modifyRequiredAtLockLevels(fdata.FormSectionFieldId, fdata.RequiredLockLevel, selectedValues.length > 0 ? "remove" : "add");
                    let multiselect_options = []
                    data.FormSectionFieldOption.filter(
                        (x) => x.FormSectionFieldId === fdata.FormSectionFieldId
                    ).forEach((option) => {
                        let selectedValue = selectedValues.find(
                            (x) => x.value.trim() === option.OptionValue.trim()
                        )

                        multiselect_options.push({
                            text: option.OptionText.trim(),
                            value: option.OptionValue.trim(),
                            valueId: selectedValue ? selectedValue.valueId : 0,
                        })
                    })
                    let validation_wrapper_children = []
                    if (fdata.IsRequired && selectedValues.length === 0)
                        validation_wrapper_children.push(
                            React.createElement('input', {
                                className: 'validation-dummy',
                                style: { height: '32px', width: '450px' },
                                onKeyPress: (e) => e.preventDefault(),
                                required: 'required',
                                onBlur: () => stageChange(fdata, fdata.StringFieldValue),
                            })
                        )

                    validation_wrapper_children.push(
                        React.createElement(Typeahead, {
                            align: 'left',
                            bsSize: 'small',
                            'data-changed': fdata.isChangedRow,
                            selected: selectedValues,
                            labelKey: 'text',
                            multiple: true,
                            clearButton: true,
                            key: `${i}v`,
                            id: inputId,
                            name: inputId,
                            onChange: (selected) => fieldChangeFunc(selected),
                            onKeyPress: handleKeyPress,
                            onInvalid: fieldInvalidFunc,
                            onBlur: () => stageChange(fdata, fdata.StringFieldValue),
                            options: multiselect_options,
                            valueKey: 'value',
                            disabled: isDisabled,
                        })
                    )

                    form_group_children.push(
                        React.createElement('div', {}, validation_wrapper_children)
                    )
                } else if (fdata.ValidationType.toUpperCase() === 'WAREHOUSE') {
                    if (fdata.StringFieldValue === null) fdata.StringFieldValue = ''
                    else if (fdata.StringFieldValue !== '')
                        bMissingRequiredLockLevelFieldsChanged =
                            modifyMissingRequiredLockLevelFields(
                                newMissingRequiredLockLevelFields,
                                fdata.FormSectionFieldId,
                                fdata.RequiredLockLevel,
                                'remove'
                            ) || bMissingRequiredLockLevelFieldsChanged
                    // modifyRequiredAtLockLevels(fdata.FormSectionFieldId, fdata.RequiredLockLevel, "remove");
                    form_group_children.push(
                        React.createElement(WarehouseDropDownList, {
                            name: inputId,
                            awclocationsonly: 'true',
                            className: 'form-control form-control-sm',
                            defaultValue: fdata.StringFieldValue,
                            onChange: fieldChangeFunc,
                            onKeyPress: handleKeyPress,
                            onInvalid: fieldInvalidFunc,
                            onBlur: () => stageChange(fdata, fdata.StringFieldValue),
                            'data-changed': fdata.isChangedRow,
                            key: `${i}v`,
                            required: isRequired ? 'required' : '',
                            disabled: isDisabled,
                        })
                    )
                } else if (fdata.ValidationType.toUpperCase() === 'PASSWORD SIGNATURE') {
                    newSignatureFields.push({
                        FormSectionFieldId: fdata.FormSectionFieldId,
                        LockLevel: fdata.LockLevel,
                        index: i,
                    })
                    if (fdata.StringFieldValue === null) fdata.StringFieldValue = ''
                    else if (fdata.StringFieldValue !== '')
                        bMissingRequiredLockLevelFieldsChanged =
                            modifyMissingRequiredLockLevelFields(
                                newMissingRequiredLockLevelFields,
                                fdata.FormSectionFieldId,
                                fdata.RequiredLockLevel,
                                'remove'
                            ) || bMissingRequiredLockLevelFieldsChanged
                    form_group_children.push(
                        React.createElement(ValidatedNameSignature, {
                            name: inputId,
                            defaultValue: fdata.StringFieldValue,
                            onChange: fieldChangeFunc,
                            //clear: clearSig && recordLockLevel < fdata.LockLevel,
                            preCheck: signPreCheck(
                                fdata.IncreaseLockLevel,
                                fdata.FormSectionFieldId,
                                fdata
                            ),
                            'data-changed': fdata.isChangedRow,
                            key: `${i}v`,
                            required: isRequired ? 'required' : '',
                            disabled: isDisabled ? 'disabled' : '',
                            onSuccess: () => {
                                let result = handleSignFunc()
                                // result = is signable
                                // if(result)
                                //     stageChange(fdata, fdata.StringFieldValue)
                                return result
                            },
                            onSuccessAfterChange: (newVal) => {
                                stageChange(fdata, newVal)
                            },
                        })
                    )
                } else if (fdata.ValidationType.toUpperCase() === 'ASSEMBLY QR SCAN') {
                    form_group_children.push(
                        React.createElement(QRScan, {
                            name: inputId,
                            handleClick: handleQrScan,
                        })
                    )
                } else if (fdata.ValidationType.toUpperCase() === 'TAG UID') {
                    if (fdata.NumericFieldValue)
                        bMissingRequiredLockLevelFieldsChanged =
                            modifyMissingRequiredLockLevelFields(
                                newMissingRequiredLockLevelFields,
                                fdata.FormSectionFieldId,
                                fdata.RequiredLockLevel,
                                'remove'
                            ) || bMissingRequiredLockLevelFieldsChanged
                    else if (fdata.RequiredLockLevel)
                        bMissingRequiredLockLevelFieldsChanged =
                            modifyMissingRequiredLockLevelFields(
                                newMissingRequiredLockLevelFields,
                                fdata.FormSectionFieldId,
                                fdata.RequiredLockLevel,
                                'add'
                            ) || bMissingRequiredLockLevelFieldsChanged

                    form_group_children.push(
                        React.createElement(AssemblyIDSelection, {
                            name: inputId,
                            handleAssemblyIDSelection: handleAssemblyIDSelection,
                            serialNumber: getSerialNumber(data),
                            UID:
                                data.FormSectionFieldValueView.find(
                                    (d) => d.FieldNameQuery === 'TagUID'
                                )?.NumericFieldValue || 0, // Provide a default value if undefined
                            salesOrderNumber:
                                data.FormSectionFieldValueView.find(
                                    (d) => d.FieldNameQuery === 'OrderNumber'
                                )?.StringFieldValue || '', // Provide a default value if undefined
                            aWCAssemblyUIDList: aWCAssemblyUIDList,
                            handleCreateNewUidClick: newAssemblyIDClick,
                            handleAssemblyIdChange: handleAssemblyIdChange,
                            disabled: isDisabled,
                            isNewAssembly: data.OrderInfo[0].ServiceType === 'A' ? true : false,
                            showAssemblyListModal, 
                            setShowAssemblyListModal,
                        })
                    )
                } else if (fdata.ValidationType.toUpperCase() === 'PICTURE') {
                    if (
                        data.FormSectionFieldAttachment.find(
                            (att) => att.FormSectionFieldId === fdata.FormSectionFieldId
                        )
                    )
                        bMissingRequiredLockLevelFieldsChanged =
                            modifyMissingRequiredLockLevelFields(
                                newMissingRequiredLockLevelFields,
                                fdata.FormSectionFieldId,
                                fdata.RequiredLockLevel,
                                'remove'
                            ) || bMissingRequiredLockLevelFieldsChanged
                    else if (fdata.RequiredLockLevel)
                        bMissingRequiredLockLevelFieldsChanged =
                            modifyMissingRequiredLockLevelFields(
                                newMissingRequiredLockLevelFields,
                                fdata.FormSectionFieldId,
                                fdata.RequiredLockLevel,
                                'add'
                            ) || bMissingRequiredLockLevelFieldsChanged

                    // modifyRequiredAtLockLevels(fdata.FormSectionFieldId, fdata.RequiredLockLevel, "remove");
                    let galleryAttachments = []
                    data.FormSectionFieldAttachment.filter(
                        (att) =>
                            att.FormSectionFieldId === fdata.FormSectionFieldId &&
                            att.ContentType.toUpperCase().startsWith('IMAGE')
                    ).forEach((att) => {
                        const formAttachmentURL = `${getBaseURL()}webapi/form/formattachment/${
                            att.SystemFilename
                        }`
                        // let caption =
                        //     data.FormSectionFieldAttachmentMultiValue
                        //         .filter(a => a.FormSectionFieldId === att.FormSectionFieldId &&
                        //             a.SystemFilename === att.SystemFilename)
                        //         .map(b => b.StringFieldValue)
                        //         .join(' - ') + (att.Caption !== '' ? ' - ' + att.Caption : '');
                        let tempCaption = ''
                        data.FormSectionFieldAttachmentMultiValue.forEach((val) => {
                            if (val.SystemFilename === att.SystemFilename) {
                                if (!tempCaption.includes(val.StringFieldValue)) {
                                    tempCaption += `${val.StringFieldValue}, `
                                }
                            }
                        })
                        if (att.Caption) {
                            tempCaption += `${att.Caption}`
                        } else {
                            if (tempCaption) {
                                tempCaption = tempCaption.substring(0, tempCaption.length - 2)
                            }
                        }
                        galleryAttachments.push({
                            src: formAttachmentURL,
                            caption: att.Caption,
                            thumbnail: `${formAttachmentURL}t`,
                            // thumbnailCaption: `${att.Caption.substr(
                            //     0,
                            //     Math.min(att.Caption.length, 15)
                            // )}${att.Caption.length > 15 ? '...' : ''}`,
                            thumbnailCaption: tempCaption,
                            thumbnailWidth: 120,
                            thumbnailHeight: 120,
                            SystemFilename: att.SystemFilename,
                        })
                    })

                    const addPictureFunc = handleGalleryAddPicture(fdata.FormSectionFieldId)
                    const updateFieldsFunc = handleGalleryAttachmentUpdateFields(
                        fdata.FormSectionFieldId
                    )
                    // const sortPictureFunc = handleGalleryImageSort(fdata.FormSectionFieldId);
                    let galleryOptions = []
                    data.FormSectionFieldOption.filter(
                        (o) => o.FormSectionFieldId === fdata.FormSectionFieldId
                    ).forEach((option) => {
                        galleryOptions.push({
                            text: option.OptionText.trim(),
                            value: option.OptionValue.trim(),
                        })
                    })
                    let selectedOptions = []
                    data.FormSectionFieldAttachmentMultiValue.filter(
                        (o) => o.FormSectionFieldId === fdata.FormSectionFieldId
                    ).forEach((option) => {
                        selectedOptions.push({
                            SystemFilename: option.SystemFilename,
                            Value: option.StringFieldValue.trim(),
                        })
                    })
                    form_group_children.push(
                        React.createElement(ImageGallery, {
                            name: inputId,
                            fieldId: fdata.FormSectionFieldId,
                            title: fdata.FieldName,
                            options: galleryOptions,
                            selectedOptions: selectedOptions,
                            images: galleryAttachments,
                            onAddPicture: (dataUri, selectedOptions, caption) => {
                                addPictureFunc(dataUri, selectedOptions, caption)
                                stageChange(fdata, fdata.StringFieldValue, true)
                                fieldChangeFunc()
                            },
                            onUpdateFields: (systemFilename, selectedOptions, caption) => {
                                updateFieldsFunc(systemFilename, selectedOptions, caption)
                                fieldChangeFunc()
                            },
                            // onCaptionChange: (index, caption) => {
                            //     handleGalleryImageCaptionChange(fdata.FormSectionFieldId, index, caption);
                            //     fieldChangeFunc();
                            // },
                            onSortPicture: (oldIndex, newIndex) => {
                                handleGalleryImageSort(fdata.FormSectionFieldId, oldIndex, newIndex)
                                fieldChangeFunc()
                            },
                            onClickRemoveSelectedPictures: (deletedImages) => {
                                handleGalleryOnClickRemoveSelectedPictures(deletedImages)
                                fieldChangeFunc()
                            },
                            rowHeight: 120,
                            key: `${i}v`,
                            required: isRequired ? 'required' : '',
                            disabled: isDisabled,
                        })
                    )
                }
            }
            let form_group = React.createElement(
                'div',
                {
                    key: `${i}form_group`,
                    className:
                        fdata.ValidationType.toUpperCase().startsWith('RADIOBUTTONGROUP') ||
                        fdata.ValidationType.toUpperCase().startsWith('RADIOBUTTONS')
                            ? ''
                            : 'form-group',
                },
                form_group_children
            )
            if (inTable) {
                table_children.push(form_group_children)
            } else section_children.push(form_group)
        })
        //}
        if (inTable) {
            let tableInfo = data.FormFieldGroup.find((x) => x.FormFieldGroupId === lastTableId)
            section_children.push(renderTable(table_children, tableInfo))
            table_children = []
        }
        sections_children.push(renderSectionTitleContainer(`${lastSectionId}`, section_children))

        elements.push(
            React.createElement(
                'div',
                {
                    key: 'sections',
                    id: 'sections',
                    className: 'sections',
                },
                sections_children
            )
        )

        if (props.disableSubmits || disableSubmits || formOrError !== 'form') {
            elements.push(
                React.createElement(
                    'div',
                    {
                        key: 'veil',
                        id: 'veil',
                        className: 'veil',
                    },
                    React.createElement(
                        'div',
                        {
                            key: 'imgLoadingContainer',
                            id: 'imgLoadingContainer',
                            style: { textAlign: 'center' },
                        },
                        React.createElement('img', {
                            alt: 'Saving...',
                            src: imgLoading,
                            id: 'imgLoading',
                            style: { height: '100px', width: '100px' },
                        })
                    )
                )
            )
        }

        if (newSignatureFields.length > 0 && signatureFields.length === 0)
            setSignatureFields(newSignatureFields)

        if (bMissingRequiredLockLevelFieldsChanged)
            setMissingRequiredLockLevelFields([...newMissingRequiredLockLevelFields])

        if (maxLevel > numLevels) setNumLevels(maxLevel)

        if (missingRequiredLockLevelFields.length === 0 && requiredLockLevelFields.length > 0)
            setMissingRequiredLockLevelFields(requiredLockLevelFields)

        let endTime = new Date()
        // if (clearSig)
        //     setClearSig(false);
        // if (dataChanged)
        //     setData(newData);
        return <StickyContainer>{elements}</StickyContainer>
    }
}
